import React from 'react'

type AgentStatus = 'active' | 'pending_review' | 'rejected' | 'inactive'

const STATUS_CONFIG: Record<AgentStatus, { bg: string; color: string; label: string }> = {
  active:         { bg: 'rgba(34,197,94,0.12)',   color: 'var(--success)', label: '✅ Active' },
  pending_review: { bg: 'rgba(234,179,8,0.12)',   color: 'var(--warning)', label: '⏳ Pending Review' },
  rejected:       { bg: 'rgba(239,68,68,0.12)',   color: 'var(--error)',   label: '❌ Rejected' },
  inactive:       { bg: 'rgba(107,114,128,0.12)', color: '#6b7280', label: '○ Inactive' },
}

interface AgentStatusBadgeProps {
  status: string
  style?: React.CSSProperties
}

export const AgentStatusBadge: React.FC<AgentStatusBadgeProps> = ({ status, style }) => {
  const cfg = STATUS_CONFIG[status as AgentStatus] ?? STATUS_CONFIG.inactive
  return (
    <span style={{
      padding: '0.2rem 0.6rem',
      borderRadius: 20,
      fontSize: '0.72rem',
      fontWeight: 700,
      background: cfg.bg,
      color: cfg.color,
      whiteSpace: 'nowrap',
      ...style,
    }}>
      {cfg.label}
    </span>
  )
}
